import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { IntroScreen, MainScreen } from "../screens";
var RootStack = createStackNavigator();
export function RootStackNavigator() {
    return /*#__PURE__*/ _jsxs(RootStack.Navigator, {
        screenOptions: {
            cardStyle: {
                backgroundColor: "white",
                flex: 1
            }
        },
        initialRouteName: "Main",
        children: [
            /*#__PURE__*/ _jsx(RootStack.Screen, {
                name: "Main",
                component: MainScreen,
                options: {
                    headerShown: false
                }
            }, "Main"),
            /*#__PURE__*/ _jsx(RootStack.Screen, {
                name: "Intro",
                component: IntroScreen
            }, "Intro")
        ]
    });
}
